import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route, Redirect, useHistory } from "react-router-dom";
import jsDig from "utils/jsDig";
import { v4 as uuidv4 } from "uuid";
import ScrollToTop from "./ScrollToTop";
import Confetti from "react-dom-confetti";
import Intro1 from "./Intro";
import Company_Name from "./CompanyName";
import Company_Type from "./CompanyType";
import Services from "./Services";
import Brand_Logo from "./BrandLogo";
import Website from "./Website";
import Company_Legal_Information from "./CompanyLegalInformation";
import Datapulse_Access from "./DatapulseAccess";
import Invoice_Recipients from "./InvoiceRecipients";
import Permissions from "./Permissions";
import Team_Access_Intro from "./TeamAccess/TeamAccessIntro";
import Shopify_Access from "./TeamAccess/ShopifyAccess";
import Shopify_Authenticate from "./TeamAccess/ShopifyAuthenticate";
import Google_Analytics_Access from "./TeamAccess/GoogleAnalyticsAccess";
import Google_Ads_Access from "./TeamAccess/GoogleAdsAccess";
import Microsoft_Ads_Access from "./TeamAccess/MicrosoftAdsAccess";
import Google_Merchant_Access from "./TeamAccess/GoogleMerchantAccess";
import DataFeedWatch_Install from "./TeamAccess/DataFeedWatchInstall";
import Facebook_Ads_Access from "./TeamAccess/FacebookAdsAccess";
import Tiktok_Ads_Access from "./TeamAccess/TiktokAdsAccess";
import Youtube_Access from "./TeamAccess/YoutubeAccess";
import Google_Search_Console_Access from "./TeamAccess/GoogleSearchConsoleAccess";
import Google_My_Business_Access from "./TeamAccess/GoogleMyBusinessAccess";
import Service_Agreements_Intro from "./ServiceAgreementsIntro";
import PPC_Service_Agreements from "./PPCServiceAgreements";
import SEO_Service_Agreements from "./SEOServiceAgreements";
import Account_Configuration_Intro from "./AccountConfigurationIntro";
import PPC_Configuration_Intro from "./PPCConfigurationIntro";
import Track_Specific_Action_IDs from "./TrackSpecificActionIds";
import Social_Conversions from "./SocialConversions/SocialConversions";
import Inflation from "./Inflation/Inflation";
import All_Campaign_Groups from "./CampaignGroups/AllCampaignGroups";
import Ppc_Data_Pull from "./PpcDataPull";
import All_PPC_Goals from "./Goals/AllPPCGoals";
import Search_Goals from "./Goals/SearchGoals";
import Social_Goals from "./Goals/SocialGoals";
import Display_Goals from "./Goals/DisplayGoals";
import Video_Goals from "./Goals/VideoGoals";
import Scripts from "./Scripts";
import PPC_Dashboard_Customization from "./PPCDashboardCustomization/PPCDashboardCustomization";
import PPC_Dashboard_Customization_All from "./PPCDashboardCustomization/PPCDashboardCustomizationAll";
import SEO_Configuration_Intro from "./SEOConfigurationIntro";
import Keyword_Groups from "./KeywordGroups";
import Landing_Pages from "./LandingPages";
import SEMRush_Setup from "./SEMRushSetup";
import Google_Analytics_Goal_Tracking from "./GoogleAnalyticsGoalTracking";
import SEO_Goals from "./Goals/SEOGoals";
import SEO_Dashboard_Customization from "./SEODashboardCustomization";
import SeoAlerts from "./SeoAlerts";
import Seo_Data_Pull from "./SeoDataPull";
import Progress_Bar from "./ProgressBar";
import Complete from "./Complete";
import Not_Complete from "./NotComplete";
import allMetrics from "data/allMetrics.js";
import PpcAlerts from "./PpcAlerts";
import { cloneDeep } from "lodash-es";

const allMetricData = allMetrics();

export const RouterContext = React.createContext();

export default function Onboarding(props) {
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

  const [routerHistory, setRouterHistory] = useState(
    jsDig(["routerHistory"], window.localStorage) === null
      ? []
      : jsDig(["routerHistory"], window.localStorage) === ""
        ? []
        : jsDig(["routerHistory"], window.localStorage) === undefined
          ? []
          : JSON.parse(jsDig(["routerHistory"], window.localStorage))
  );

  let history = useHistory();

  //DETERMINE IF ONBOARDING IS COMPLETE
  const [onboardingComplete, setOnboardingComplete] = useState(false);

  //  GENERAL INFO STATE

  //Confetti Time!!
  const confettiConfig = {
    angle: "85",
    spread: "83",
    startVelocity: "30",
    elementCount: "125",
    dragFriction: "0.03",
    duration: "5000",
    stagger: "0",
    width: "8px",
    height: "31px",
    perspective: "1000px",
    colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
  };
  const [confettiTrigger, setConfettiTrigger] = useState(false);
  //company_name
  const [companyName, setCompanyName] = useState(props.client_company.company_name ? props.client_company.company_name : "");
  //company_type
  const [accountType, setAccountType] = useState(props.client_account.account_type == "ecommerce" ? 0 : 1);
  //services
  const [searchEnabled, setSearchEnabled] = useState(props.search_section.enabled === true ? true : false);
  const [displayEnabled, setDisplayEnabled] = useState(props.display_section.enabled === true ? true : false);
  const [socialEnabled, setSocialEnabled] = useState(props.social_section.enabled === true ? true : false);
  const [videoEnabled, setVideoEnabled] = useState(props.video_section.enabled === true ? true : false);
  const [seoEnabled, setSeoEnabled] = useState(props.seo_section.enabled === true ? true : false);
  //brand_logo - base64Img is false unless it has been changed
  const [base64Img, setBase64Img] = useState(false);
  //website
  const website = jsDig(["client_account", "websites", "primary"], props) ? jsDig(["client_account", "websites", "primary"], props) : "";
  const additionalWebsites = jsDig(["client_account", "websites", "additional"], props);
  const [primarySite, setPrimarySite] = useState(website);
  const [additionalWebs, setAdditionalWebs] = useState(additionalWebsites ? additionalWebsites : []);
  const handleOnChange = (e, i) => {
    let newArray = additionalWebs;
    newArray[i].url = e.target.value;
    setAdditionalWebs([...newArray]);
  };
  const handleDelete = (i) => {
    setAdditionalWebs(
      additionalWebs.filter((web) => {
        return web.id !== i;
      })
    );
  };
  const addRow = () => {
    let newitem = {};
    newitem.url = "";
    newitem.id = uuidv4();
    setAdditionalWebs([...additionalWebs, newitem]);
  };
  const [webPlatform, setWebPlatform] = useState(jsDig(["website_platform"], props.client_account) ? jsDig(["website_platform"], props.client_account) : 0);
  const handleSelect = (value) => {
    setWebPlatform(value);
  };
  //comany_legal_information
  const [legalInfo, setLegalInfo] = useState([
    props.client_company.legal_company_name,
    props.client_company.street_address,
    props.client_company.unit_building_number,
    props.client_company.city,
    props.client_company.state_province,
    props.client_company.postal_code,
  ]);
  const legalChange = (e, index) => {
    let updated = e.target.value;
    let newArray = legalInfo;
    legalInfo[index] = updated;
    setLegalInfo([...newArray]);
  };

  //datapulse_access
  const [firstAlert, setFirstAlert] = useState(false);
  const [lastAlert, setLastAlert] = useState(false);
  const [poc, setPoc] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [job, setJob] = useState("");

  // Only personBoxes will get created into new users
  const [personBoxes, setPersonBoxes] = useState([]);
  const [showUsers, setShowUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState(props.client_account.client_users ? props.client_account.client_users : []);
  const addNewPerson = () => {
    let newPoc = {};
    newPoc.id = uuidv4();
    newPoc.email = "";
    newPoc.first_name = "";
    newPoc.last_name = "";
    newPoc.phone_number = "";
    newPoc.job_title = "";
    newPoc.account_access_ids = [props.client_account.id];
    newPoc.is_primary_point_of_contact = false;

    if (showUsers.findIndex((showUser) => showUser[1].id == newPoc.id) < 0) {
      setPersonBoxes((personBoxes) => [...personBoxes, newPoc]);
      setSelectedUsers([...selectedUsers, email]);
      setShowUsers((showUsers) => [...showUsers, [email, newPoc]]);
    }
  };

  const changePerson = (id, email, property, value) => {
    let newShowUsers = showUsers;
    let newShowUsersIndex = newShowUsers.findIndex((box) => box[1].id == id);
    newShowUsers[newShowUsersIndex][1][property] = value;
    if (property == "email") {
      newShowUsers[newShowUsersIndex][0] = value;
    }
    setShowUsers([...newShowUsers]);

    let newPeople = personBoxes;
    let personIndex = newPeople.findIndex((user) => user.id == id);
    newPeople[personIndex][property] = value;
    setPersonBoxes([...newPeople]);

    if (property == "email") {
      let newSelectedUsers = selectedUsers;
      let newSelectedUsersIndex = newSelectedUsers.findIndex((userEmail) => userEmail == email);
      newSelectedUsers[newSelectedUsersIndex] = value;
      setSelectedUsers(newSelectedUsers);
    }
  };

  const removePerson = (id, email) => {
    setShowUsers(showUsers.filter((box) => box[1].id !== id));

    let selection = [...selectedUsers];
    selection.splice(selection.indexOf(email), 1);
    setSelectedUsers(selection);

    let newPeople = personBoxes;
    let personIndex = newPeople.findIndex((user) => user.id == id);
    newPeople.splice(personIndex, 1);
    setPersonBoxes([...newPeople]);
  };

  const phoneChange = (phone) => {
    const cleaned = ("" + phone).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    setPhone("(" + match[1] + ") " + match[2] + "-" + match[3]);
  };
  //invoice_recipients
  const [invoiceRecipients, setInvoiceRecipients] = useState(props.billing_config.invoice_recipients);
  const handleDeleteRecipient = (id) => {
    const newInvoices = invoiceRecipients.filter((el) => el.id !== id);
    setInvoiceRecipients([...newInvoices]);
  };
  const handleAddRecipient = () => {
    setInvoiceRecipients([...invoiceRecipients, { id: uuidv4(), email: "" }]);
  };
  //permissions
  const [globalPermission, setGlobalPermission] = useState(
    props.client_account.global_website_permissions ? props.client_account.global_website_permissions : undefined
  );
  const [isPermissionsEnabled, setIsPermissionsEnabled] = useState(
    props.client_account.custom_website_permissions_enabled ? props.client_account.custom_website_permissions_enabled : false
  );
  const [customPermissions, setCustomPermissions] = useState(
    jsDig(["client_account", "custom_website_permissions"], props)
      ? jsDig(["client_account", "custom_website_permissions"], props)
      : [{ id: uuidv4(), website: "", permission: 1 }]
  );
  const permissionHandler = (items) => {
    if (!isPermissionsEnabled) {
      return;
    }
    setCustomPermissions(items);
  };
  const [developmentCapabilities, setDevelopmentCapabilities] = useState(
    props.client_account.development_capabilities ? props.client_account.development_capabilities : 0
  );
  const [creativeCapabilities, setCreativeCapabilities] = useState(
    props.client_account.creative_capabilities ? props.client_account.creative_capabilities : 0
  );
  /* team access */
  const platforms = [
    "Google Analytics",
    "Google Ads",
    "Microsoft Ads",
    "Google Merchant",
    "DataFeedWatch",
    "Facebook Ads",
    "Tiktok Ads",
    "Youtube",
    "Google Search Console",
    "SEMRush",
    "Shopify",
    "Google Business",
  ];
  let defaultTeamAccess = props.client_account.team_access ? props.client_account.team_access : {};
  platforms.forEach((platformName) => {
    defaultTeamAccess[platformName] = defaultTeamAccess[platformName] || { Restricted: "0" };
  });
  const [teamAccess, setTeamAccess] = useState(defaultTeamAccess);
  const [shopifyChannel, setShopifyChannel] = useState(jsDig(["shopify_revenue_type"], props.ppc_section));
  const [domainProperty, setDomainProperty] = useState(undefined);
  /* shopify url */
  let shopifyUrlTemp = props.client_account.shopify_url;
  if (shopifyUrlTemp) {
    shopifyUrlTemp = shopifyUrlTemp.split(".myshopify.com")[0];
  }
  const [shopifyUrl, setShopifyUrl] = useState(shopifyUrlTemp);
  /* platform data */
  const [googleAnalyticsIds, setGoogleAnalyticsIds] = useState(
    jsDig(["platform_data", "google_analytics", "account_ids"], props.seo_section)
      ? jsDig(["platform_data", "google_analytics", "account_ids"], props.seo_section)
      : []
  );
  const [sameId, setSameId] = useState(true);
  const [searchGoogleAdsIds, setSearchGoogleAdsIds] = useState(
    jsDig(["platform_data", "google_ads", "account_ids", "id"], props.search_section)
      ? jsDig(["platform_data", "google_ads", "account_ids"], props.search_section)
      : [{ id: "" }]
  );
  const [displayGoogleAdsIds, setDisplayGoogleAdsIds] = useState(
    jsDig(["platform_data", "google_ads", "account_ids", "id"], props.display_section)
      ? jsDig(["platform_data", "google_ads", "account_ids"], props.display_section)
      : [{ id: "" }]
  );
  const [videoGoogleAdsIds, setVideoGoogleAdsIds] = useState(
    jsDig(["platform_data", "google_ads", "account_ids", "id"], props.video_section)
      ? jsDig(["platform_data", "google_ads", "account_ids"], props.video_section)
      : [{ id: "" }]
  );
  const [allGoogleAdsIds, setAllGoogleAdsIds] = useState(
    videoGoogleAdsIds[0]["id"] == displayGoogleAdsIds[0]["id"] && displayGoogleAdsIds[0]["id"] == searchGoogleAdsIds[0]["id"]
      ? jsDig(["platform_data", "google_ads", "account_ids"], props.search_section)
      : [{ id: "" }]
  );

  const setGoogleAdsIds = (id) => {
    setSearchGoogleAdsIds(id);
    setDisplayGoogleAdsIds(id);
    setVideoGoogleAdsIds(id);
  };

  // Google Ads Access
  const [mccId, setMccId] = useState(props.organization.google_ads_mcc_id)
  const savedMccId = props.organization.google_ads_mcc_id

  const [semrushApiKey, setSemrushApiKey] = useState(props.organization.semrush_api_key)
  const savedSemrushKey = props.organization.semrush_api_key

  const [facebookAdsIds, setFacebookAdsIds] = useState(
    jsDig(["platform_data", "facebook_ads", "account_ids"], props.social_section)
      ? jsDig(["platform_data", "facebook_ads", "account_ids"], props.social_section)
      : []
  );
  const [tiktokAdsIds, setTiktokAdsIds] = useState(
    jsDig(["platform_data", "tiktok_ads", "account_ids"], props.social_section)
      ? jsDig(["platform_data", "tiktok_ads", "account_ids"], props.social_section)
      : []
  );
  const [microsoftAdsIds, setMicrosoftAdsIds] = useState(
    jsDig(["platform_data", "microsoft_ads", "account_ids"], props.search_section)
      ? jsDig(["platform_data", "microsoft_ads", "account_ids"], props.search_section)
      : []
  );
  /* conversion_actions */
  const [conversionActions, setConversionActions] = useState({
    search: jsDig(["conversion_actions"], props.search_section),
    display: jsDig(["conversion_actions"], props.display_section),
    video: jsDig(["conversion_actions"], props.video_section),
  });
  /* social conversions */
  const [facebookCustomConversions, setFacebookCustomConversions] = useState(props.social_section.custom_conversions);
  const [facebookConversionObjective, setFacebookConversionObjective] = useState(props.social_section.conversion_objective);
  const [tiktokConversionObjective, setTiktokConversionObjective] = useState(props.social_section.tiktok_conversion_objective);
  /* data pull */
  const [pullBoxes, setPullBoxes] = useState([
    ["Google Ads", "[search]google_ads", false],
    ["Microsoft Ads", "[search]microsoft_ads", false],
    ["SEMRush", "[seo]pull_semrush_data", false],
    ["Google Search Console", "[seo]pull_search_console_data", false],
    ["Google: SEO", "[seo]pull_google_data", false],
    ["Google: Display", "[display]google_ads", false],
    ["Google: Video", "[video]google_ads", false],
    ["Facebook", "[social]facebook_ads", false],
    ["Tiktok", "[social]tiktok_ads", false],
    ["Shopify", "[ppc]shopify", false],
  ]);
  const [pullPlatforms, setPullPlatform] = useState({
    search: {
      google_ads: "0",
      microsoft_ads: "0",
    },
    social: {
      facebook_ads: "0",
      tiktok_ads: "0",
    },
    display: {
      google_ads: "0",
    },
    video: {
      google_ads: "0",
    },
    seo: {
      pull_google_data: "0",
      pull_search_console_data: "0",
      pull_semrush_data: "0",
    },
    ppc: {
      shopify: "0",
    },
  });
  useEffect(() => {
    const newPlatforms = cloneDeep(pullPlatforms);
    pullBoxes[0][2] === true ? (newPlatforms["search"]["google_ads"] = "1") : (newPlatforms["search"]["google_ads"] = "0");
    pullBoxes[1][2] === true ? (newPlatforms["search"]["microsoft_ads"] = "1") : (newPlatforms["search"]["microsoft_ads"] = "0");
    pullBoxes[2][2] === true ? (newPlatforms["seo"]["pull_semrush_data"] = "1") : (newPlatforms["seo"]["pull_semrush_data"] = "0");
    pullBoxes[3][2] === true ? (newPlatforms["seo"]["pull_search_console_data"] = "1") : (newPlatforms["seo"]["pull_search_console_data"] = "0");
    pullBoxes[4][2] === true ? (newPlatforms["seo"]["pull_google_data"] = "1") : (newPlatforms["seo"]["pull_google_data"] = "0");
    pullBoxes[5][2] === true ? (newPlatforms["display"]["google_ads"] = "1") : (newPlatforms["display"]["google_ads"] = "0");
    pullBoxes[6][2] === true ? (newPlatforms["video"]["google_ads"] = "1") : (newPlatforms["video"]["google_ads"] = "0");
    pullBoxes[7][2] === true ? (newPlatforms["social"]["facebook_ads"] = "1") : (newPlatforms["social"]["facebook_ads"] = "0");
    pullBoxes[8][2] === true ? (newPlatforms["social"]["tiktok_ads"] = "1") : (newPlatforms["social"]["tiktok_ads"] = "0");
    pullBoxes[9][2] === true && props.client_account.shopify_token !== null ? (newPlatforms["ppc"]["shopify"] = "1") : (newPlatforms["ppc"]["shopify"] = "0");
    setPullPlatform({ ...newPlatforms });
  }, [pullBoxes]);

  const manualDataPull = () => {
    let myObject = {
      client_account_id: props.client_account.id,
      pull_platform_data: pullPlatforms,
    };

    $.ajax({
      type: "POST",
      url: "/datapulse/onboarding/manual_pull",
      dataType: "json",
      async: false,
      contentType: "application/json",
      data: JSON.stringify(myObject),
    });
  };

  const videoInflation =
    Object.keys(jsDig(["daily_yields"], props.social_section)).length > 0
      ? jsDig(["daily_yields"], props.video_section)
      : {
        google: {
          conversions: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
          revenue: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
        },
      };

  const displayInflation =
    Object.keys(jsDig(["daily_yields"], props.display_section)).length > 0
      ? jsDig(["daily_yields"], props.display_section)
      : {
        google: {
          conversions: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
          revenue: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
        },
      };

  const socialInflation =
    Object.keys(jsDig(["daily_yields"], props.social_section)).length > 0
      ? jsDig(["daily_yields"], props.social_section)
      : {
        facebook: {
          conversions: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
          revenue: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
        },
        tiktok: {
          conversions: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
          revenue: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
        }
      };

  const searchInflation =
    Object.keys(jsDig(["daily_yields"], props.search_section)).length > 0
      ? jsDig(["daily_yields"], props.search_section)
      : {
        google: {
          conversions: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
          revenue: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
        },
        microsoft: {
          conversions: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
          revenue: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: "",
            6: "",
            7: "",
            8: "",
            9: "",
            10: "",
            11: "",
            12: "",
            13: "",
            14: "",
            15: "",
            16: "",
            17: "",
            18: "",
            19: "",
            20: "",
            21: "",
            22: "",
            23: "",
            24: "",
            25: "",
            26: "",
            27: "",
            28: "",
            29: "",
            30: "0",
          },
        },
      };
  /* inflation */
  const [inflation, setInflation] = useState({
    search: searchInflation,
    social: socialInflation,
    display: displayInflation,
    video: videoInflation,
  });
  /* campaign groups */
  const [campaignGroups, setCampaignGroups] = useState(props.campaign_groups);
  /* goals */
  let allGoals = {
    seo: {
      0: jsDig(["goals"], props.seo_section),
    },
    ppc: {
      0: jsDig(["goals"], props.ppc_section),
    },
    search: {
      0: jsDig(["goals"], props.search_section),
    },
    social: {
      0: jsDig(["goals"], props.social_section),
    },
    display: {
      0: jsDig(["goals"], props.display_section),
    },
    video: {
      0: jsDig(["goals"], props.video_section),
    },
  };
  props.seo_section.landing_page_groups.forEach((group) => {
    allGoals.seo[group.id] = group.goals;
  });
  const ppcPlatformsArray = ["search", "social", "display", "video"];
  ppcPlatformsArray.forEach((service) => {
    let section = props[service + "_section"];
    section.campaign_groups.forEach((group) => {
      allGoals[service][group.id] = group.goals;
    });
  });

  const [goals, setGoals] = useState(allGoals);
  const [scripts, setScripts] = useState(props.client_account.scripts);
  /* service agreements */
  const [searchUniqueFeeEnabled, setSearchUniqueFeeEnabled] = useState(props.billing_config.search_fee_structure_enabled === true ? true : false);
  const [displayUniqueFeeEnabled, setDisplayUniqueFeeEnabled] = useState(props.billing_config.display_fee_structure_enabled === true ? true : false);
  const [socialUniqueFeeEnabled, setSocialUniqueFeeEnabled] = useState(props.billing_config.social_fee_structure_enabled === true ? true : false);
  const [videoUniqueFeeEnabled, setVideoUniqueFeeEnabled] = useState(props.billing_config.video_fee_structure_enabled === true ? true : false);
  const [seoAccountLeads, setSeoAccountLeads] = useState(props.seo_section.account_leads ? props.seo_section.account_leads : []);
  const [seoAccountSupports, setSeoAccountSupports] = useState(props.seo_section.account_supports ? props.seo_section.account_supports : []);
  const [searchAccountLeads, setSearchAccountLeads] = useState(props.search_section.account_leads ? props.search_section.account_leads : []);
  const [searchAccountSupports, setSearchAccountSupports] = useState(props.search_section.account_supports ? props.search_section.account_supports : []);
  const [socialAccountLeads, setSocialAccountLeads] = useState(props.social_section.account_leads ? props.social_section.account_leads : []);
  const [socialAccountSupports, setSocialAccountSupports] = useState(props.social_section.account_supports ? props.social_section.account_supports : []);
  const [displayAccountLeads, setDisplayAccountLeads] = useState(props.display_section.account_leads ? props.display_section.account_leads : []);
  const [displayAccountSupports, setDisplayAccountSupports] = useState(props.display_section.account_supports ? props.display_section.account_supports : []);
  const [videoAccountLeads, setVideoAccountLeads] = useState(props.video_section.account_leads ? props.video_section.account_leads : []);
  const [videoAccountSupports, setVideoAccountSupports] = useState(props.video_section.account_supports ? props.video_section.account_supports : []);
  const [seoPointsOfContact, setSeoPointsOfContact] = useState(props.client_account.seo_points_of_contact ? props.client_account.seo_points_of_contact : []);
  const [ppcPointsOfContact, setPpcPointsOfContact] = useState(props.client_account.ppc_points_of_contact ? props.client_account.ppc_points_of_contact : []);
  const [ppcWhiteLabelService, setPpcWhiteLabelService] = useState(props.search_section.white_label_service ? props.search_section.white_label_service : false);
  const [seoWhiteLabelService, setSeoWhiteLabelService] = useState(props.seo_section.white_label_service ? props.seo_section.white_label_service : false);
  const [ppcStartDate, setPpcStartDate] = useState(props.billing_config.ppc_start_date ? new Date(props.billing_config.ppc_start_date) : undefined);
  const [seoStartDate, setSeoStartDate] = useState(props.billing_config.seo_start_date ? props.billing_config.seo_start_date : undefined);
  const [displayFeeStructure, setDisplayFeeStructure] = useState(
    props.billing_config.display_fee_structure && props.billing_config.video_fee_structure[0]
      ? props.billing_config.display_fee_structure
      : [
        {
          id: uuidv4(),
          flat_fee: "0",
          over_ad_spend: "0",
          percentage_fee: "0",
          flat_fee_enabled: "0",
          percentage_fee_enabled: "0",
          percentage_fee_total_over: "total",
        },
      ]
  );
  const [searchFeeStructure, setSearchFeeStructure] = useState(
    props.billing_config.search_fee_structure && props.billing_config.video_fee_structure[0]
      ? props.billing_config.search_fee_structure
      : [
        {
          id: uuidv4(),
          flat_fee: "0",
          over_ad_spend: "0",
          percentage_fee: "0",
          flat_fee_enabled: "0",
          percentage_fee_enabled: "0",
          percentage_fee_total_over: "total",
        },
      ]
  );
  const [socialFeeStructure, setSocialFeeStructure] = useState(
    props.billing_config.social_fee_structure && props.billing_config.video_fee_structure[0]
      ? props.billing_config.social_fee_structure
      : [
        {
          id: uuidv4(),
          flat_fee: "0",
          over_ad_spend: "0",
          percentage_fee: "0",
          flat_fee_enabled: "0",
          percentage_fee_enabled: "0",
          percentage_fee_total_over: "total",
        },
      ]
  );
  const [videoFeeStructure, setVideoFeeStructure] = useState(
    props.billing_config.video_fee_structure && props.billing_config.video_fee_structure[0]
      ? props.billing_config.video_fee_structure
      : [
        {
          id: uuidv4(),
          flat_fee: "0",
          over_ad_spend: "0",
          percentage_fee: "0",
          flat_fee_enabled: "0",
          percentage_fee_enabled: "0",
          percentage_fee_total_over: "total",
        },
      ]
  );
  const [ppcFeeStructure, setPpcFeeStructure] = useState(
    props.billing_config.ppc_fee_structure
      ? props.billing_config.ppc_fee_structure
      : [
        {
          id: uuidv4(),
          flat_fee: "0",
          over_ad_spend: "0",
          percentage_fee: "0",
          flat_fee_enabled: "0",
          percentage_fee_enabled: "0",
          percentage_fee_total_over: "total",
        },
      ]
  );
  const seoFeeStructureinitial = props.billing_config.seo_fee_structure
    ? props.billing_config.seo_fee_structure.map((el) => {
      if (!el.id) {
        el["id"] = uuidv4();
        return el;
      }
      return el;
    })
    : [];
  const [seoFeeStructure, setSEOFeeStructure] = useState(seoFeeStructureinitial);
  const [ppcFees, setPpcFees] = useState(
    props.billing_config.ppc_fees
      ? props.billing_config.ppc_fees
      : [
        {
          id: uuidv4(),
          label: "",
          amount: "0",
          status: "0",
          enabled: "0",
          status: "Recurring",
          frequency: "Monthly",
        },
      ]
  );
  const seoFeesinitial = props.billing_config.seo_fees
    ? props.billing_config.seo_fees.map((el) => {
      if (!el.id) {
        el["id"] = uuidv4();
        return el;
      }
      return el;
    })
    : [
      {
        id: uuidv4(),
        label: "",
        amount: "0",
        status: "0",
        enabled: "0",
        status: "Recurring",
        frequency: "Monthly",
      },
    ];
  const [seoFees, setSeoFees] = useState(seoFeesinitial);
  const searchScriptsInitial = {
    google_ads_search_impressions_emergency_detector: "0",
    google_ads_search_disapproved_ads_detector: "0",
    google_ads_search_out_of_stock_detector: "0",
    google_ads_search_impressions_flux_detector: "0",
    google_ads_search_clicks_flux_detector: "0",
    google_ads_search_keyword_bleeder_detector: "0",
    google_ads_search_url_issue_detector: "0",
    google_ads_search_spend_flux_detector: "0",
    google_ads_search_conversions_flux_detector: "0",
    google_ads_shopping_campaign_fluctuation_detector: "0",
    google_ads_shopping_product_fluctuation_detector: "0",
    bing_ads_search_impressions_emergency_detector: "0",
    bing_ads_search_disapproved_ads_detector: "0",
    bing_ads_search_impressions_flux_detector: "0",
    bing_ads_search_clicks_flux_detector: "0",
    bing_ads_search_keyword_bleeder_detector: "0",
    bing_ads_search_spend_flux_detector: "0",
    bing_ads_search_conversions_flux_detector: "0",
  };
  const searchScriptsVarInitial = {
    google_ads_search_impressions_flux_detector: { min_threshold: "", max_threshold: "" },
    google_ads_search_clicks_flux_detector: { min_threshold: "", max_threshold: "" },
    google_ads_search_keyword_bleeder_detector: { threshold: "" },
    google_ads_search_spend_flux_detector: { min_threshold: "", max_threshold: "" },
    google_ads_search_conversions_flux_detector: { min_threshold: "", max_threshold: "" },
    google_ads_shopping_campaign_fluctuation_detector: { min_threshold: "", max_threshold: "" },
    bing_ads_search_impressions_flux_detector: { min_threshold: "", max_threshold: "" },
    bing_ads_search_clicks_flux_detector: { min_threshold: "", max_threshold: "" },
    bing_ads_search_keyword_bleeder_detector: { threshold: "" },
    bing_ads_search_spend_flux_detector: { min_threshold: "", max_threshold: "" },
    bing_ads_search_conversions_flux_detector: { min_threshold: "", max_threshold: "" },
  };
  const socialScriptsInitial = {
    facebook_ads_social_impressions_emergency_detector: "0",
    facebook_ads_social_impressions_flux_detector: "0",
    facebook_ads_social_spend_flux_detector: "0",
    facebook_ads_social_clicks_flux_detector: "0",
    facebook_ads_social_conversions_flux_detector: "0",
  };
  const socialScriptsVarInitial = {
    facebook_ads_social_impressions_flux_detector: { min_threshold: "", max_threshold: "" },
    facebook_ads_social_spend_flux_detector: { min_threshold: "", max_threshold: "" },
    facebook_ads_social_clicks_flux_detector: { min_threshold: "", max_threshold: "" },
    facebook_ads_social_conversions_flux_detector: { min_threshold: "", max_threshold: "" },
  };

  const displayScriptsInitial = {
    google_ads_display_impressions_emergency_detector: "0",
    google_ads_display_disapproved_ads_detector: "0",
    google_ads_display_out_of_stock_detector: "0",
    google_ads_display_impressions_flux_detector: "0",
    google_ads_display_clicks_flux_detector: "0",
    google_ads_display_keyword_bleeder_detector: "0",
    google_ads_display_url_issue_detector: "0",
    google_ads_display_spend_flux_detector: "0",
    google_ads_display_conversions_flux_detector: "0",
  };
  const displayScriptsVarInitial = {
    google_ads_display_impressions_flux_detector: { min_threshold: "", max_threshold: "" },
    google_ads_display_clicks_flux_detector: { min_threshold: "", max_threshold: "" },
    google_ads_display_keyword_bleeder_detector: { threshold: "" },
    google_ads_display_spend_flux_detector: { min_threshold: "", max_threshold: "" },
    google_ads_display_conversions_flux_detector: { min_threshold: "", max_threshold: "" },
  };

  const videoScriptsInitial = {
    google_ads_video_impressions_emergency_detector: "0",
    google_ads_video_disapproved_ads_detector: "0",
    google_ads_video_out_of_stock_detector: "0",
    google_ads_video_impressions_flux_detector: "0",
    google_ads_video_clicks_flux_detector: "0",
    google_ads_video_keyword_bleeder_detector: "0",
    google_ads_video_url_issue_detector: "0",
    google_ads_video_spend_flux_detector: "0",
    google_ads_video_conversions_flux_detector: "0",
  };
  const videoScriptsVarInitial = {
    google_ads_video_impressions_flux_detector: { min_threshold: "", max_threshold: "" },
    google_ads_video_clicks_flux_detector: { min_threshold: "", max_threshold: "" },
    google_ads_video_keyword_bleeder_detector: { threshold: "" },
    google_ads_video_spend_flux_detector: { min_threshold: "", max_threshold: "" },
    google_ads_video_conversions_flux_detector: { min_threshold: "", max_threshold: "" },
  };

  const seoScriptsInitial = {
    google_analytics_seo_traffic_fluctuation_detector: "0",
  };
  const seoScriptsVarInitial = {
    google_analytics_seo_traffic_fluctuation_detector: { min_threshold: "", max_threshold: "" },
  };
  const [searchScripts, setSearchScripts] = useState(
    jsDig(["scripts"], props.search_section) ? jsDig(["scripts"], props.search_section) : searchScriptsInitial
  );
  const [searchScriptsVar, setSearchScriptsVar] = useState(
    jsDig(["script_variables"], props.search_section) ? jsDig(["script_variables"], props.search_section) : searchScriptsVarInitial
  );
  const [socialScripts, setSocialScripts] = useState(
    jsDig(["scripts"], props.social_section) ? jsDig(["scripts"], props.social_section) : socialScriptsInitial
  );
  const [socialScriptsVar, setSocialScriptsVar] = useState(
    jsDig(["script_variables"], props.social_section) ? jsDig(["script_variables"], props.social_section) : socialScriptsVarInitial
  );
  const [displayScripts, setDisplayScripts] = useState(
    jsDig(["scripts"], props.display_section) ? jsDig(["scripts"], props.display_section) : displayScriptsInitial
  );
  const [displayScriptsVar, setDisplayScriptsVar] = useState(
    jsDig(["script_variables"], props.display_section) ? jsDig(["script_variables"], props.display_section) : displayScriptsVarInitial
  );
  const [videoScripts, setVideoScripts] = useState(jsDig(["scripts"], props.video_section) ? jsDig(["scripts"], props.video_section) : videoScriptsInitial);
  const [videoScriptsVar, setVideoScriptsVar] = useState(
    jsDig(["script_variables"], props.video_section) ? jsDig(["script_variables"], props.video_section) : videoScriptsVarInitial
  );

  const [seoScripts, setSeoScripts] = useState(jsDig(["scripts"], props.seo_section) ? jsDig(["scripts"], props.seo_section) : seoScriptsInitial);
  const [seoScriptsVar, setSeoScriptsVar] = useState(
    jsDig(["script_variables"], props.seo_section) ? jsDig(["script_variables"], props.seo_section) : seoScriptsVarInitial
  );

  // Seo Config
  const [allPages, setAllPages] = useState([
    ["/datapulse/onboarding/account_configuration_intro", 0]
    ["/datapulse/onboarding/company_type", 1],
    ["/datapulse/onboarding/services", 2],
    ["/datapulse/onboarding/brand_logo", 3],
    ["/datapulse/onboarding/website", 4],
    ["/datapulse/onboarding/company_legal_information", 5],
    ["/datapulse/onboarding/datapulse_access", 6],
    ["/datapulse/onboarding/invoice_recipients", 7],
    ["/datapulse/onboarding/permissions", 8],
    ["/datapulse/onboarding/team_access_intro", 9],
    ["/datapulse/onboarding/shopify_access", 10],
    ["/datapulse/onboarding/shopify_authenticate", 11],
    ["/datapulse/onboarding/facebook_ads_access", 12],
    ["/datapulse/onboarding/tiktok_ads_access", 13],
    ["/datapulse/onboarding/google_ads_access", 14],
    ["/datapulse/onboarding/google_analytics_access", 15],
    ["/datapulse/onboarding/google_merchant_access", 16],
    ["/datapulse/onboarding/google_my_business_access", 17],
    ["/datapulse/onboarding/google_search_console_access", 18],
    ["/datapulse/onboarding/microsoft_ads_access", 19],
    ["/datapulse/onboarding/youtube_access", 20],
    ["/datapulse/onboarding/service_agreements_intro", 21],
    ["/datapulse/onboarding/ppc_service_agreements", 22],
    ["/datapulse/onboarding/seo_service_agreements", 23],
    ["/datapulse/onboarding/ppc_configuration_intro", 24],
    ["/datapulse/onboarding/track_specific_action_ids", 25],
    ["/datapulse/onboarding/social_conversions", 26],
    ["/datapulse/onboarding/inflation", 27],
    ["/datapulse/onboarding/campaign_groups", 28],
    ["/datapulse/onboarding/all_ppc_goals", 29],
    ["/datapulse/onboarding/search_goals", 30],
    ["/datapulse/onboarding/social_goals", 31],
    ["/datapulse/onboarding/display_goals", 32],
    ["/datapulse/onboarding/video_goals", 33],
    ["/datapulse/onboarding/ppc_dashboard_customization", 34],
    ["/datapulse/onboarding/ppc_dashboard_customization_all", 35],
    ["/datapulse/onboarding/ppc_data_pull", 36],
    ["/datapulse/onboarding/datafeedwatch_install", 37],
    ["/datapulse/onboarding/scripts", 38],
    ["/datapulse/onboarding/ppc_alerts", 39],
    ["/datapulse/onboarding/seo_configuration_intro", 40],
    ["/datapulse/onboarding/keyword_groups", 41],
    ["/datapulse/onboarding/landing_pages", 42],
    ["/datapulse/onboarding/semrush_setup", 43],
    ["/datapulse/onboarding/google_analytics_goal_tracking", 44],
    ["/datapulse/onboarding/seo_goals", 45],
    ["/datapulse/onboarding/seo_dashboard_customization", 46],
    ["/datapulse/onboarding/seo_data_pull", 47],
    ["/datapulse/onboarding/seo_alerts", 48],
    ["/datapulse/onboarding/complete", 49],
  ]);

  const [teamAccessChoices, setTeamAccessChoices] = useState(
    jsDig(["teamChoices"], window.localStorage) !== "undefined" && jsDig(["teamChoices"], window.localStorage) !== undefined
      ? JSON.parse(jsDig(["teamChoices"], window.localStorage))
      : [
        "google_analytics_access",
        "google_ads_access",
        "microsoft_ads_access",
        "google_merchant_access",
        "datafeedwatch_install",
        "facebook_ads_access",
        "tiktok_ads_access",
        "youtube_access",
        "google_search_console_access",
        "google_my_business_access",
        "test"
      ]
  );

  const teamAccessNav = (currentPage) => {
    const exists = teamAccessChoices.filter((el) => el.includes(currentPage));
    if (exists.length !== 0) {
      const index = teamAccessChoices.indexOf(currentPage);
      if (index !== teamAccessChoices.length - 1) {
        return teamAccessChoices[index + 1];
      }
    }
    return "service_agreements_intro";
  };

  const pageLocator = () => {
    return useEffect(() => {
      let current = allPages.filter((el) => el[0] === window.location.pathname);
      if (current[0] === undefined) {
        return;
      }
      if (current[0] === `/datapulse/onboarding/complete`) {
        setPercent((prevState) => ({ ...prevState, currentPage: 100 }));
      } else {
        setPercent((prevState) => ({ ...prevState, currentPage: current[0][1] }));
      }
    }, []);
  };
  const [percent, setPercent] = useState({
    currentPage: 0,
    totalPages: allPages.length,
    lastPercent: 0,
    percent: function () {
      let complete = props.onboarding_progress.filter((page) => page.completed == true).length;
      let total = props.onboarding_progress.length;
      return Math.floor((complete / (total > 0 ? total : 1)) * 100);
    },
  });

  const initialKeywordGroups =
    props.keyword_groups.length > 0
      ? props.keyword_groups
      : [
        {
          name: "",
          conditions: [
            { word: "", contains: "" },
            { word: "", contains: "" },
          ],
        },
      ];

  const [keywordGroups, setKeywordGroups] = useState(initialKeywordGroups);
  const [landingPageGroups, setLandingPageGroups] = useState(props.seo_section.landing_page_groups ? props.seo_section.landing_page_groups : []);
  const semrushInitialIds = jsDig(["platform_data", "semrush", "project_ids"], props.seo_section)
    ? jsDig(["platform_data", "semrush", "project_ids"], props.seo_section).map((el) => {
      if (!el.website) el.website = primarySite;
      return el;
    })
    : undefined;
  const [semRushIds, setSemRushIds] = useState(jsDig(["platform_data", "semrush", "project_ids"], props.seo_section) ? semrushInitialIds : []);
  const [customAnalyticGoals, setCustomAnalyticaGoals] = useState(props.seo_section.custom_analytics_goals ? props.seo_section.custom_analytics_goals : {});
  const [customAnalyticGoalsEnabled, setCustomAnalyticaGoalsEnabled] = useState(props.seo_section.custom_analytics_goals_enabled ? true : false);

  const defaultMetrics = (service, sectionName) => {
    const defaults = jsDig(["metricsByDashboard", service, "defaults", accountType == 1 ? "leadgen" : "ecommerce", sectionName], allMetricData);
    return Object.keys(defaults ? defaults : {});
  };

  const seoSectionList = jsDig(["metricsByDashboard", "seo", "sections"], allMetricData);
  const [seoDefault, setSeoDefault] = useState(props.seo_section.default_dash_used !== null ? props.seo_section.default_dash_used : true);
  let initialSeoDashboardOrder =
    !(props.seo_section.dashboard_order && props.seo_section.dashboard_order.length > 0) || seoDefault
      ? Object.keys(seoSectionList).map((sectionName, index) => ({
        name: sectionName,
        order: index,
        metrics_data: defaultMetrics("seo", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
        enabled: sectionName != "goalsAndProjections",
      }))
      : props.seo_section.dashboard_order.map((el, index) => {
        el.order = index;
        return el;
      });

  let seoInitialDashboards = [{ name: "SEO: Overall", id: 0, dashboardOrder: initialSeoDashboardOrder }];
  props.seo_section.landing_page_groups.forEach((el, idx) => {
    seoInitialDashboards.push({
      name: el.name,
      id: el.id,
      dashboardOrder:
        !(el.dashboard_order && el.dashboard_order.length > 0) || seoDefault
          ? Object.keys(seoSectionList)
            .filter((section) => section != "landingPageBreakdown")
            .map((sectionName, index) => ({
              name: sectionName,
              order: index,
              metrics_data: defaultMetrics("seo", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
              enabled: sectionName != "goalsAndProjections",
            }))
          : el.dashboard_order.map((el, index) => {
            el.order = index;
            return el;
          }),
    });
  });

  const ppcSectionList = jsDig(["metricsByDashboard", "ppc", "sections"], allMetricData);
  const [ppcDefault, setPpcDefault] = useState(props.ppc_section.default_dash_used !== null ? props.ppc_section.default_dash_used : true);
  let initialPpcDashboardOrder =
    !(props.ppc_section.dashboard_order && props.ppc_section.dashboard_order.length > 0) || ppcDefault
      ? Object.keys(ppcSectionList).map((sectionName, index) => ({
        name: sectionName,
        order: index,
        metrics_data: defaultMetrics("ppc", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
        enabled: sectionName != "goalsAndProjections",
      }))
      : props.ppc_section.dashboard_order.map((el, index) => {
        el.order = index;
        return el;
      });
  let ppcInitialDashboards = [{ name: "PPC: Overall", id: 0, dashboardOrder: initialPpcDashboardOrder }];

  const displaySectionList = jsDig(["metricsByDashboard", "display", "sections"], allMetricData);
  const [displayDefault, setDisplayDefault] = useState(props.display_section.default_dash_used !== null ? props.display_section.default_dash_used : true);
  let initialDisplayDashboardOrder =
    !(props.display_section.dashboard_order && props.display_section.dashboard_order.length > 0) || displayDefault
      ? Object.keys(displaySectionList).map((sectionName, index) => ({
        name: sectionName,
        order: index,
        metrics_data: defaultMetrics("display", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
        enabled: sectionName != "goalsAndProjections",
      }))
      : props.display_section.dashboard_order.map((el, index) => {
        el.order = index;
        return el;
      });
  let displayInitialDashboards = [{ name: "Display: Overall", id: 0, dashboardOrder: initialDisplayDashboardOrder }];
  props.display_section.campaign_groups.forEach((el, idx) => {
    displayInitialDashboards.push({
      name: el.name,
      id: el.id,
      dashboardOrder:
        !(el.dashboard_order && el.dashboard_order.length > 0) || displayDefault
          ? Object.keys(displaySectionList)
            .filter((section) => section != "campaignGroups")
            .map((sectionName, index) => ({
              name: sectionName,
              order: index,
              metrics_data: defaultMetrics("display", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
              enabled: sectionName != "goalsAndProjections",
            }))
          : el.dashboard_order.map((el, index) => {
            el.order = index;
            return el;
          }),
    });
  });

  const searchSectionList = jsDig(["metricsByDashboard", "search", "sections"], allMetricData);
  const [searchDefault, setSearchDefault] = useState(props.search_section.default_dash_used !== null ? props.search_section.default_dash_used : true);
  let initialSearchDashboardOrder =
    !(props.search_section.dashboard_order && props.search_section.dashboard_order.length > 0) || searchDefault
      ? Object.keys(searchSectionList).map((sectionName, index) => ({
        name: sectionName,
        order: index,
        metrics_data: defaultMetrics("search", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
        enabled: sectionName != "goalsAndProjections" ? true : false,
      }))
      : props.search_section.dashboard_order.map((el, index) => {
        el.order = index;
        return el;
      });
  let searchInitialDashboards = [{ name: "Search: Overall", id: 0, dashboardOrder: initialSearchDashboardOrder }];
  props.search_section.campaign_groups.forEach((el, idx) => {
    searchInitialDashboards.push({
      name: el.name,
      id: el.id,
      dashboardOrder:
        !(el.dashboard_order && el.dashboard_order.length > 0) || searchDefault
          ? Object.keys(searchSectionList)
            .filter((section) => section != "campaignGroups")
            .map((sectionName, index) => ({
              name: sectionName,
              order: index,
              metrics_data: defaultMetrics("search", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
              enabled: sectionName != "goalsAndProjections",
            }))
          : el.dashboard_order.map((el, index) => {
            el.order = index;
            return el;
          }),
    });
  });

  const socialSectionList = jsDig(["metricsByDashboard", "social", "sections"], allMetricData);
  const [socialDefault, setSocialDefault] = useState(props.social_section.default_dash_used !== null ? props.social_section.default_dash_used : true);
  let initialSocialDashboardOrder =
    !(props.social_section.dashboard_order && props.social_section.dashboard_order.length > 0) || socialDefault
      ? Object.keys(socialSectionList).map((sectionName, index) => ({
        name: sectionName,
        order: index,
        metrics_data: defaultMetrics("social", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
        enabled: sectionName != "goalsAndProjections" ? true : false,
      }))
      : props.social_section.dashboard_order.map((el, index) => {
        el.order = index;
        return el;
      });
  let socialInitialDashboards = [{ name: "Social: Overall", id: 0, dashboardOrder: initialSocialDashboardOrder }];
  props.social_section.campaign_groups.forEach((el, idx) => {
    socialInitialDashboards.push({
      name: el.name,
      id: el.id,
      dashboardOrder:
        !(el.dashboard_order && el.dashboard_order.length > 0) || socialDefault
          ? Object.keys(socialSectionList)
            .filter((section) => section != "campaignGroups")
            .map((sectionName, index) => ({
              name: sectionName,
              order: index,
              metrics_data: defaultMetrics("social", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
              enabled: sectionName != "goalsAndProjections" ? true : false,
            }))
          : el.dashboard_order.map((el, index) => {
            el.order = index;
            return el;
          }),
    });
  });
  const videoSectionList = jsDig(["metricsByDashboard", "video", "sections"], allMetricData);
  const [videoDefault, setVideoDefault] = useState(props.video_section.default_dash_used !== null ? props.video_section.default_dash_used : true);
  let initialVideoDashboardOrder =
    !(props.video_section.dashboard_order && props.video_section.dashboard_order.length > 0) || videoDefault
      ? Object.keys(videoSectionList).map((sectionName, index) => ({
        name: sectionName,
        order: index,
        metrics_data: defaultMetrics("video", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
        enabled: sectionName != "goalsAndProjections" ? true : false,
      }))
      : props.video_section.dashboard_order.map((el, index) => {
        el.order = index;
        return el;
      });
  let videoInitialDashboards = [{ name: "Video: Overall", id: 0, dashboardOrder: initialVideoDashboardOrder }];
  props.video_section.campaign_groups.forEach((el, idx) => {
    videoInitialDashboards.push({
      name: el.name,
      id: el.id,
      dashboardOrder:
        !(el.dashboard_order && el.dashboard_order.length > 0) || videoDefault
          ? Object.keys(videoSectionList)
            .filter((section) => section != "campaignGroups")
            .map((sectionName, index) => ({
              name: sectionName,
              order: index,
              metrics_data: defaultMetrics("video", sectionName).reduce((acc, metric) => ((acc[metric] = "1"), acc), {}),
              enabled: sectionName != "goalsAndProjections" ? true : false,
            }))
          : el.dashboard_order.map((el, index) => {
            el.order = index;
            return el;
          }),
    });
  });

  const [seoDashboard, setSeoDashboard] = useState(seoInitialDashboards);
  const [ppcDashboard, setPpcDashboard] = useState(ppcInitialDashboards);
  const [displayDashboard, setDisplayDashboard] = useState(displayInitialDashboards);
  const [searchDashboard, setSearchDashboard] = useState(searchInitialDashboards);
  const [socialDashboard, setSocialDashboard] = useState(socialInitialDashboards);
  const [videoDashboard, setVideoDashboard] = useState(videoInitialDashboards);

  const submitForm = (url = "/datapulse/onboarding") => {
    // Submit the form with javascript so that we can construct the params we send to the controller
    const submitUrl = "/datapulse/onboarding";
    //changing the uniform params structure
    let seoDashBoardData = {};
    seoDashboard.forEach((el) => (seoDashBoardData[`${el.id}`] = el.dashboardOrder));
    let ppcDashboardData = {};
    ppcDashboard.forEach((el) => (ppcDashboardData[`${el.id}`] = el.dashboardOrder));
    let searchDashboardData = {};
    searchDashboard.forEach((el) => (searchDashboardData[`${el.id}`] = el.dashboardOrder));
    let displayDashboardData = {};
    displayDashboard.forEach((el) => (displayDashboardData[`${el.id}`] = el.dashboardOrder));
    let videoDashboardData = {};
    videoDashboard.forEach((el) => (videoDashboardData[`${el.id}`] = el.dashboardOrder));
    let socialDashboardData = {};
    socialDashboard.forEach((el) => (socialDashboardData[`${el.id}`] = el.dashboardOrder));
    let paramsObject = {
      current_page: window.location.pathname,
      conversion_actions: conversionActions,
      facebook_custom_conversions: facebookCustomConversions,
      facebook_conversion_objective: facebookConversionObjective,
      tiktok_conversion_objective: tiktokConversionObjective,
      inflation: inflation,
      campaign_groups: campaignGroups,
      goals: goals,
      scripts: scripts,
      org_id: props.organization.id,
      google_ads_mcc_id: mccId,
      semrush_api_key: semrushApiKey,
      ppc_fee_structure: ppcFeeStructure,
      seo_fee_structure: seoFeeStructure,
      video_fee_structure: videoFeeStructure,
      social_fee_structure: socialFeeStructure,
      display_fee_structure: displayFeeStructure,
      search_fee_structure: searchFeeStructure,
      ppc_fees: ppcFees,
      seo_fees: seoFees,
      client_account_id: props.client_account.id,
      company_name: companyName,
      account_type: accountType == "0" ? "ecommerce" : "leadgen",
      legal_company_name: legalInfo[0],
      street_address: legalInfo[1],
      unit_building_number: legalInfo[2],
      city: legalInfo[3],
      state_province: legalInfo[4],
      postal_code: legalInfo[5],
      seo_enabled: seoEnabled,
      video_enabled: videoEnabled,
      social_enabled: socialEnabled,
      display_enabled: displayEnabled,
      search_enabled: searchEnabled,
      video_fee_structure_enabled: videoUniqueFeeEnabled,
      social_fee_structure_enabled: socialUniqueFeeEnabled,
      display_fee_structure_enabled: displayUniqueFeeEnabled,
      search_fee_structure_enabled: searchUniqueFeeEnabled,
      websites: {
        primary: primarySite,
        additional: additionalWebs,
      },
      website_platform: webPlatform,
      invoice_recipients: invoiceRecipients,
      development_capabilities: developmentCapabilities,
      creative_capabilities: creativeCapabilities,
      global_website_permissions: globalPermission,
      custom_website_permissions: customPermissions,
      custom_website_permissions_enabled: isPermissionsEnabled,
      team_access: teamAccess,
      shopify_channel: shopifyChannel,
      shopify_url: shopifyUrl ? shopifyUrl.split(".myshopify.com")[0] + ".myshopify.com" : "",
      google_analytics_ids: googleAnalyticsIds,
      search_google_ads_id: sameId ? allGoogleAdsIds : searchGoogleAdsIds,
      display_google_ads_id: sameId ? allGoogleAdsIds : displayGoogleAdsIds,
      video_google_ads_id: sameId ? allGoogleAdsIds : videoGoogleAdsIds,
      social_facebook_ads_id: facebookAdsIds,
      social_tiktok_ads_id: tiktokAdsIds,
      search_microsoft_ads_id: microsoftAdsIds,
      authenticity_token: authenticityToken,
      current_onboarding_page: window.location.origin,
      supporting_roles: {
        seo: { account_leads: seoAccountLeads, account_support: seoAccountSupports },
        search: { account_leads: searchAccountLeads, account_support: searchAccountSupports },
        social: { account_leads: socialAccountLeads, account_support: socialAccountSupports },
        display: { account_leads: displayAccountLeads, account_support: displayAccountSupports },
        video: { account_leads: videoAccountLeads, account_support: videoAccountSupports },
      },
      points_of_contact: { seo: seoPointsOfContact, ppc: ppcPointsOfContact },
      ppc_section: { white_label_service: ppcWhiteLabelService },
      seo_section: { white_label_service: seoWhiteLabelService },
      ppc_start_date: ppcStartDate,
      seo_start_date: seoStartDate,
      client_users: selectedUsers,
      new_users: personBoxes,
      keyword_groups: keywordGroups,
      semrush_ids: semRushIds,
      // pull_platform_data: pullPlatforms ,
      landing_page_groups: landingPageGroups,
      custom_analytics_goals: customAnalyticGoals,
      custom_analytics_goals_enabled: customAnalyticGoalsEnabled,
      dashboard_builder: {
        seo_default: seoDefault,
        ppc_default: ppcDefault,
        search_default: searchDefault,
        display_default: displayDefault,
        video_default: videoDefault,
        social_default: socialDefault,
        seo: seoDashBoardData,
        ppc: ppcDashboardData,
        search: searchDashboardData,
        display: displayDashboardData,
        video: videoDashboardData,
        social: socialDashboardData,
      },
      search_scripts: searchScripts,
      search_script_variables: searchScriptsVar,
      social_scripts: socialScripts,
      social_script_variables: socialScriptsVar,
      display_scripts: displayScripts,
      display_script_variables: displayScriptsVar,
      video_scripts: videoScripts,
      video_script_variables: videoScriptsVar,
      seo_scripts: seoScripts,
      seo_script_variables: seoScriptsVar,
      domain_property: domainProperty,
    };
    // Don't bother processing an image upload if the image wasn't changed
    if (base64Img != false) {
      paramsObject["logo"] = base64Img;
    }

    $.ajax({
      type: "POST",
      url: submitUrl,
      dataType: "json",
      async: false,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        // location.reload();
        //change it back to below before push
        // window.location.href = data.redirect_url;
        if (percent.currentPage == 9 && props.client_account.website_platform !== 0) {
          window.location.href = url;
        } else {
          window.location.href = url;
        }
      },
    });
  };
  const basicRoutes = [
    ["Account_Configuration_Intro", <Account_Configuration_Intro pageLocator={pageLocator} submitForm={submitForm} {...props} />],
    ["Company_Type", <Company_Type accountType={accountType} pageLocator={pageLocator} setAccountType={setAccountType} submitForm={submitForm} {...props} />],
    [
      "Services",
      <Services
        pageLocator={pageLocator}
        seo={seoEnabled}
        setSeo={setSeoEnabled}
        setVideoEnabled={setVideoEnabled}
        videoEnabled={videoEnabled}
        setSocialEnabled={setSocialEnabled}
        socialEnabled={socialEnabled}
        setSearchEnabled={setSearchEnabled}
        searchEnabled={searchEnabled}
        setDisplayEnabled={setDisplayEnabled}
        displayEnabled={displayEnabled}
        submitForm={submitForm}
        {...props}
      />,
    ],
    ["Brand_Logo", <Brand_Logo pageLocator={pageLocator} setBase64Img={setBase64Img} submitForm={submitForm} {...props} />],
    [
      "Website",
      <Website
        pageLocator={pageLocator}
        handleSelect={handleSelect}
        webPlatform={webPlatform}
        clientAccountId={props.client_account.id}
        primarySite={primarySite}
        setPrimarySite={setPrimarySite}
        additionalWebs={additionalWebs}
        handleOnChange={handleOnChange}
        addRow={addRow}
        handleDelete={handleDelete}
        submitForm={submitForm}
        {...props}
      />,
    ],
    [
      "Company_Legal_Information",
      <Company_Legal_Information
        pageLocator={pageLocator}
        legalChange={legalChange}
        legalInfo={legalInfo}
        setLegalInfo={setLegalInfo}
        submitForm={submitForm}
        {...props}
      />,
    ],
    [
      "Datapulse_Access",
      <Datapulse_Access
        firstAlert={firstAlert}
        pageLocator={pageLocator}
        setFirstAlert={setFirstAlert}
        lastAlert={lastAlert}
        setLastAlert={setLastAlert}
        selectedUsers={selectedUsers}
        selectedAccountId={props.client_account.id}
        showUsers={showUsers}
        setShowUsers={setShowUsers}
        clientUsers={props.client_users}
        poc={poc}
        setPoc={setPoc}
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
        email={email}
        setEmail={setEmail}
        phone={phone}
        setPhone={setPhone}
        job={job}
        setJob={setJob}
        addNewPerson={addNewPerson}
        removePerson={removePerson}
        changePerson={changePerson}
        phoneChange={phoneChange}
        submitForm={submitForm}
        {...props}
      />,
    ],
    [
      "Invoice_Recipients",
      <Invoice_Recipients
        pageLocator={pageLocator}
        invoiceRecipients={invoiceRecipients}
        setInvoiceRecipients={setInvoiceRecipients}
        handleDeleteRecipient={handleDeleteRecipient}
        handleAddRecipient={handleAddRecipient}
        submitForm={submitForm}
        {...props}
      />,
    ],
    [
      "Permissions",
      <Permissions
        permissionHandler={permissionHandler}
        globalPermission={globalPermission}
        pageLocator={pageLocator}
        developmentCapabilities={developmentCapabilities}
        setDevelopmentCapabilities={setDevelopmentCapabilities}
        creativeCapabilities={creativeCapabilities}
        setCreativeCapabilities={setCreativeCapabilities}
        setGlobalPermission={setGlobalPermission}
        global_website_permissions={props.client_account.global_website_permissions}
        isPermissionsEnabled={isPermissionsEnabled}
        setIsPermissionsEnabled={setIsPermissionsEnabled}
        customPermissions={customPermissions}
        setCustomPermissions={setCustomPermissions}
        submitForm={submitForm}
        {...props}
      />,
    ],
    [
      "Team_Access_Intro",
      <Team_Access_Intro
        submitForm={submitForm}
        {...props}
        pageLocator={pageLocator}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
        teamAccessChoices={teamAccessChoices}
        setTeamAccessChoices={setTeamAccessChoices}
        webPlatform={webPlatform}
      />,
    ],
    [
      "Shopify_Access",
      <Shopify_Access
        submitForm={submitForm}
        {...props}
        pageLocator={pageLocator}
        setTeamAccess={setTeamAccess}
        teamAccessChoices={teamAccessChoices}
        teamAccess={teamAccess}
        shopifyChannel={shopifyChannel}
        setShopifyChannel={setShopifyChannel}
        shopifyUrl={shopifyUrl}
        setShopifyUrl={setShopifyUrl}
      />,
    ],
    ["Shopify_Authenticate", <Shopify_Authenticate submitForm={submitForm} {...props} pageLocator={pageLocator} shopifyUrl={shopifyUrl} />],
    [
      "Google_Analytics_Access",
      <Google_Analytics_Access
        teamAccessNav={teamAccessNav}
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        googleAnalyticsIds={googleAnalyticsIds}
        setGoogleAnalyticsIds={setGoogleAnalyticsIds}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
      />,
    ],
    [
      "Google_Ads_Access",
      <Google_Ads_Access
        submitForm={submitForm}
        {...props}
        teamAccessNav={teamAccessNav}
        pageLocator={pageLocator}
        allGoogleAdsIds={allGoogleAdsIds}
        setAllGoogleAdsIds={setAllGoogleAdsIds}
        sameId={sameId}
        setSameId={setSameId}
        searchGoogleAdsIds={searchGoogleAdsIds}
        displayGoogleAdsIds={displayGoogleAdsIds}
        videoGoogleAdsIds={videoGoogleAdsIds}
        setSearchGoogleAdsIds={setSearchGoogleAdsIds}
        setDisplayGoogleAdsIds={setDisplayGoogleAdsIds}
        setVideoGoogleAdsIds={setVideoGoogleAdsIds}
        setTeamAccess={setTeamAccess}
        setGoogleAdsIds={setGoogleAdsIds}
        teamAccess={teamAccess}
        mccId={mccId}
        setMccId={setMccId}
        savedMccId={savedMccId}
      />,
    ],
    [
      "Microsoft_Ads_Access",
      <Microsoft_Ads_Access
        teamAccessNav={teamAccessNav}
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        microsoftAdsIds={microsoftAdsIds}
        setMicrosoftAdsIds={setMicrosoftAdsIds}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
      />,
    ],
    [
      "Google_Merchant_Access",
      <Google_Merchant_Access
        teamAccessNav={teamAccessNav}
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
      />,
    ],
    [
      "DataFeedWatch_Install",
      <DataFeedWatch_Install
        teamAccessNav={teamAccessNav}
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
      />,
    ],
    [
      "Facebook_Ads_Access",
      <Facebook_Ads_Access
        pageLocator={pageLocator}
        teamAccessNav={teamAccessNav}
        submitForm={submitForm}
        {...props}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
        facebookAdsIds={facebookAdsIds}
        setFacebookAdsIds={setFacebookAdsIds}
      />,
    ],
    [
      "Tiktok_Ads_Access",
      <Tiktok_Ads_Access
        pageLocator={pageLocator}
        teamAccessNav={teamAccessNav}
        submitForm={submitForm}
        {...props}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
        tiktokAdsIds={tiktokAdsIds}
        setTiktokAdsIds={setTiktokAdsIds}
      />,
    ],
    [
      "Youtube_Access",
      <Youtube_Access
        submitForm={submitForm}
        {...props}
        teamAccessNav={teamAccessNav}
        pageLocator={pageLocator}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
      />,
    ],
    [
      "Google_Search_Console_Access",
      <Google_Search_Console_Access
        teamAccessNav={teamAccessNav}
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
        domainProperty={domainProperty}
        setDomainProperty={setDomainProperty}
      />,
    ],
    [
      "Google_My_Business_Access",
      <Google_My_Business_Access
        teamAccessNav={teamAccessNav}
        submitForm={submitForm}
        {...props}
        pageLocator={pageLocator}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
      />,
    ],
    ["Service_Agreements_Intro", <Service_Agreements_Intro pageLocator={pageLocator} submitForm={submitForm} {...props} />],
    ["PPC_Configuration_Intro", <PPC_Configuration_Intro pageLocator={pageLocator} submitForm={submitForm} {...props} />],
    [
      "Track_Specific_Action_IDs",
      <Track_Specific_Action_IDs
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        conversionActions={conversionActions}
        setConversionActions={setConversionActions}
      />,
    ],
    [
      "Social_Conversions",
      <Social_Conversions
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        facebookCustomConversions={facebookCustomConversions}
        setFacebookCustomConversions={setFacebookCustomConversions}
        facebookConversionObjective={facebookConversionObjective}
        setFacebookConversionObjective={setFacebookConversionObjective}
        tiktokConversionObjective={tiktokConversionObjective}
        setTiktokConversionObjective={setTiktokConversionObjective}
      />,
    ],
    ["Inflation", <Inflation pageLocator={pageLocator} submitForm={submitForm} {...props} inflation={inflation} setInflation={setInflation} />],
    [
      "Campaign_Groups",
      <All_Campaign_Groups
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        campaignGroups={campaignGroups}
        setCampaignGroups={setCampaignGroups}
      />,
    ],
    [
      "Ppc_Data_Pull",
      <Ppc_Data_Pull
        ppcDashboard={ppcDashboard}
        manualDataPull={manualDataPull}
        pullBoxes={pullBoxes}
        setPullBoxes={setPullBoxes}
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
      />,
    ],
    ["All_PPC_Goals", <All_PPC_Goals pageLocator={pageLocator} submitForm={submitForm} {...props} goals={goals} setGoals={setGoals} />],
    ["Search_Goals", <Search_Goals pageLocator={pageLocator} submitForm={submitForm} {...props} goals={goals} setGoals={setGoals} />],
    ["Social_Goals", <Social_Goals pageLocator={pageLocator} submitForm={submitForm} {...props} goals={goals} setGoals={setGoals} />],
    ["Display_Goals", <Display_Goals pageLocator={pageLocator} submitForm={submitForm} {...props} goals={goals} setGoals={setGoals} />],
    ["Video_Goals", <Video_Goals pageLocator={pageLocator} submitForm={submitForm} {...props} goals={goals} setGoals={setGoals} />],
    ["Scripts", <Scripts submitForm={submitForm} {...props} pageLocator={pageLocator} scripts={scripts} setScripts={setScripts} />],
    [
      "PPC_Dashboard_Customization",
      <PPC_Dashboard_Customization
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        searchDashboard={searchDashboard}
        setSearchDashboard={setSearchDashboard}
        socialDashboard={socialDashboard}
        setSocialDashboard={setSocialDashboard}
        displayDashboard={displayDashboard}
        setDisplayDashboard={setDisplayDashboard}
        videoDashboard={videoDashboard}
        setVideoDashboard={setVideoDashboard}
        searchDefault={searchDefault}
        displayDefault={displayDefault}
        videoDefault={videoDefault}
        socialDefault={socialDefault}
        setSearchDefault={setSearchDefault}
        setDisplayDefault={setDisplayDefault}
        setVideoDefault={setVideoDefault}
        setSocialDefault={setSocialDefault}
      />,
    ],
    [
      "PPC_Dashboard_Customization_All",
      <PPC_Dashboard_Customization_All
        ppcDashboard={ppcDashboard}
        setPpcDefault={setPpcDefault}
        ppcDefault={ppcDefault}
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        setPpcDashboard={setPpcDashboard}
      />,
    ],
    [
      "PPC_Alerts",
      <PpcAlerts
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        searchScripts={searchScripts}
        setSearchScripts={setSearchScripts}
        searchScriptsVar={searchScriptsVar}
        setSearchScriptsVar={setSearchScriptsVar}
        socialScripts={socialScripts}
        setSocialScripts={setSocialScripts}
        socialScriptsVar={socialScriptsVar}
        setSocialScriptsVar={setSocialScriptsVar}
        displayScripts={displayScripts}
        setDisplayScripts={setDisplayScripts}
        displayScriptsVar={displayScriptsVar}
        setDisplayScriptsVar={setDisplayScriptsVar}
        videoScripts={videoScripts}
        setVideoScripts={setVideoScripts}
        videoScriptsVar={videoScriptsVar}
        setVideoScriptsVar={setVideoScriptsVar}
      />,
    ],

    ["SEO_Configuration_Intro", <SEO_Configuration_Intro pageLocator={pageLocator} submitForm={submitForm} {...props} />],
    [
      "Keyword_Groups",
      <Keyword_Groups submitForm={submitForm} {...props} pageLocator={pageLocator} setKeywordGroups={setKeywordGroups} keywordGroups={keywordGroups} />,
    ],
    ["Landing_Pages", <Landing_Pages submitForm={submitForm} {...props} pageLocator={pageLocator} setLandingPageGroups={setLandingPageGroups} />],
    [
      "SEMRush_Setup",
      <SEMRush_Setup
        submitForm={submitForm}
        {...props}
        pageLocator={pageLocator}
        semRushIds={semRushIds}
        setSemRushIds={setSemRushIds}
        setTeamAccess={setTeamAccess}
        teamAccess={teamAccess}
        website={primarySite}
        semrushApiKey={semrushApiKey}
        setSemrushApiKey={setSemrushApiKey}
        savedSemrushKey={savedSemrushKey}
      />,
    ],
    [
      "Google_Analytics_Goal_Tracking",
      <Google_Analytics_Goal_Tracking
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        customAnalyticGoals={customAnalyticGoals}
        setCustomAnalyticaGoals={setCustomAnalyticaGoals}
        customAnalyticGoalsEnabled={customAnalyticGoalsEnabled}
        setCustomAnalyticaGoalsEnabled={setCustomAnalyticaGoalsEnabled}
      />,
    ],
    ["SEO_Goals", <SEO_Goals submitForm={submitForm} {...props} pageLocator={pageLocator} goals={goals} setGoals={setGoals} />],
    [
      "SEO_Dashboard_Customization",
      <SEO_Dashboard_Customization
        seoDefault={seoDefault}
        setSeoDefault={setSeoDefault}
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        seoDashboard={seoDashboard}
        setSeoDashboard={setSeoDashboard}
      />,
    ],
    [
      "Seo_Data_Pull",
      <Seo_Data_Pull
        onboardingComplete={onboardingComplete}
        setOnboardingComplete={setOnboardingComplete}
        manualDataPull={manualDataPull}
        pullBoxes={pullBoxes}
        setPullBoxes={setPullBoxes}
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
      />,
    ],
    [
      "SEO_Alerts",
      <SeoAlerts
        pageLocator={pageLocator}
        submitForm={submitForm}
        {...props}
        seoScripts={seoScripts}
        setSeoScripts={setSeoScripts}
        seoScriptsVar={seoScriptsVar}
        setSeoScriptsVar={setSeoScriptsVar}
        onboardingComplete={onboardingComplete}
      />,
    ],
    [
      "SEO_Service_Agreements",
      <SEO_Service_Agreements
        submitForm={submitForm}
        {...props}
        pageLocator={pageLocator}
        setSeoPointsOfContact={setSeoPointsOfContact}
        seoPointsOfContact={seoPointsOfContact}
        setSeoAccountLeads={setSeoAccountLeads}
        seoAccountLeads={seoAccountLeads}
        setSeoAccountSupports={setSeoAccountSupports}
        seoAccountSupports={seoAccountSupports}
        seoFees={seoFees}
        setSeoFees={setSeoFees}
        seoFeeStructure={seoFeeStructure}
        setSeoFeeStructure={setSEOFeeStructure}
        seoEnabled={seoEnabled}
        setSeoEnabled={setSeoEnabled}
        setSeoWhiteLabelService={setSeoWhiteLabelService}
        setSeoStartDate={setSeoStartDate}
        seoStartDate={seoStartDate}
      />,
    ],
    [
      "PPC_Service_Agreements",
      <PPC_Service_Agreements
        submitForm={submitForm}
        {...props}
        pageLocator={pageLocator}
        ppcFeeStructure={ppcFeeStructure}
        setPpcFeeStructure={setPpcFeeStructure}
        displayFeeStructure={displayFeeStructure}
        setDisplayFeeStructure={setDisplayFeeStructure}
        searchFeeStructure={searchFeeStructure}
        setSearchFeeStructure={setSearchFeeStructure}
        socialFeeStructure={socialFeeStructure}
        setSocialFeeStructure={setSocialFeeStructure}
        videoFeeStructure={videoFeeStructure}
        setVideoFeeStructure={setVideoFeeStructure}
        displayEnabled={displayEnabled}
        setDisplayEnabled={setDisplayEnabled}
        searchEnabled={searchEnabled}
        setSearchEnabled={setSearchEnabled}
        socialEnabled={socialEnabled}
        setSocialEnabled={setSocialEnabled}
        videoEnabled={videoEnabled}
        setVideoEnabled={setVideoEnabled}
        ppcFees={ppcFees}
        setPpcFees={setPpcFees}
        searchUniqueFeeEnabled={searchUniqueFeeEnabled}
        setSearchUniqueFeeEnabled={setSearchUniqueFeeEnabled}
        socialUniqueFeeEnabled={socialUniqueFeeEnabled}
        setSocialUniqueFeeEnabled={setSocialUniqueFeeEnabled}
        displayUniqueFeeEnabled={displayUniqueFeeEnabled}
        setDisplayUniqueFeeEnabled={setDisplayUniqueFeeEnabled}
        videoUniqueFeeEnabled={videoUniqueFeeEnabled}
        setVideoUniqueFeeEnabled={setVideoUniqueFeeEnabled}
        searchAccountLeads={searchAccountLeads}
        setSearchAccountLeads={setSearchAccountLeads}
        searchAccountSupports={searchAccountSupports}
        setSearchAccountSupports={setSearchAccountSupports}
        socialAccountLeads={socialAccountLeads}
        setSocialAccountLeads={setSocialAccountLeads}
        socialAccountSupports={socialAccountSupports}
        setSocialAccountSupports={setSocialAccountSupports}
        displayAccountLeads={displayAccountLeads}
        setDisplayAccountLeads={setDisplayAccountLeads}
        displayAccountSupports={displayAccountSupports}
        setDisplayAccountSupports={setDisplayAccountSupports}
        videoAccountLeads={videoAccountLeads}
        setVideoAccountLeads={setVideoAccountLeads}
        videoAccountSupports={videoAccountSupports}
        setVideoAccountSupports={setVideoAccountSupports}
        setPpcPointsOfContact={setPpcPointsOfContact}
        ppcPointsOfContact={ppcPointsOfContact}
        setPpcWhiteLabelService={setPpcWhiteLabelService}
        setPpcStartDate={setPpcStartDate}
        ppcStartDate={ppcStartDate}
      />,
    ],
    [
      "Complete",
      <Complete
        setConfettiTrigger={setConfettiTrigger}
        pageLocator={pageLocator}
        submitForm={submitForm}
        ppcEnabled={props.search_section.enabled || props.social_section.enabled || props.display_section.enabled || props.video_section.enabled}
        {...props}
      />,
    ],
    ["Progress_Bar", <Progress_Bar submitForm={submitForm} {...props} />],
  ];
  return (
    <RouterContext.Provider
      value={{
        organization: props.organization,
        get: routerHistory,
        set: setRouterHistory,
        onboardingComplete: onboardingComplete,
        onboardingProgress: props.onboarding_progress,
        ppcServices: {
          search: props.search_section.enabled,
          setSearch: setSearchEnabled,
          social: props.social_section.enabled,
          setSocial: setSocialEnabled,
          video: props.video_section.enabled,
          setVideo: setVideoEnabled,
          display: props.display_section.enabled,
          setDisplay: setDisplayEnabled,
        },
      }}>
      <Router>
        <ScrollToTop />
        <Progress_Bar
          percent={percent}
          onboardingComplete={onboardingComplete}
          setPercent={setPercent}
          setOnboardingComplete={setOnboardingComplete}
          submitForm={submitForm}
          onboardingProgress={props.onboarding_progress}
          manualDataPull={manualDataPull}
          pullPlatforms={pullPlatforms}
        />
        <Form id="onboarding-form">
          <div className="onboarding p-3">
            <Switch>
              <Route
                exact
                path="/datapulse/onboarding"
                render={() => {
                  let shouldRedirect = props.onboarding_progress && props.onboarding_progress.length > 0;
                  if (shouldRedirect) {
                    // Just  need the first uncompleted page
                    let currentUrl = props.onboarding_progress.find((page) => page.completed == false);
                    if (currentUrl) {
                      return <Redirect to={{ pathname: "/datapulse/onboarding/not_complete" }} />;
                    } else {
                      return <Redirect to="/datapulse/onboarding/account_configuration_intro" />;
                    }
                  } else {
                    return <Redirect to="/datapulse/onboarding/account_configuration_intro" />;
                  }
                }}
              />
              <Route
                component={(routeProps) => (
                  <Not_Complete {...routeProps} submitForm={submitForm} pageLocator={pageLocator} onboarding_progress={props.onboarding_progress} />
                )}
                exact
                path="/datapulse/onboarding/not_complete"
              />

              {basicRoutes.map((page) => {
                const url = page[0].toLowerCase();
                const path = `/datapulse/onboarding/${url}`;
                return (
                  <Route key={page} path={path}>
                    {page[1]}
                  </Route>
                );
              })}
            </Switch>
          </div>
        </Form>
        <Row style={{ marginTop: "40vh" }} className="justify-content-center">
          <Col md={1}>
            <div>
              <Confetti active={confettiTrigger} config={confettiConfig} />
            </div>
          </Col>
        </Row>
      </Router>
    </RouterContext.Provider>
  );
}
